import moment from "moment";

export const savedVouchersColumns = ({
  onClickViewFile,
  onClickDownloadFile,
  deleteVoucher,
  downloadVoucherAtStoreForSaved
}) => [
  {
    Header: "Date",
    accessor: "date",
    Cell: (rowData) => {
      return <div>{rowData?.date}</div>;
    },
  },
  {
    Header: "Voucher Head",
    accessor: "head",
    Cell: (rowData) => {
      const value = rowData;

      return (
        <div className="py-4">
          <div className="font-size-small">{value?.head}</div>
          {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
            {value?.sub_head}
          </div> */}
        </div>
      );
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
  },
  {
    Header: "Voucher Comment",
    accessor: "comment",
  },
  {
    Header: "Attachment",
    accessor: "file_id",
    Cell: (rowData) => {
      return (
        <div className="flex items-center gap-x-5">
          <div
            className="cursor-pointer text-[#346BFF] underline"
            onClick={() => onClickViewFile(rowData?.file_id, rowData?.filename)}
          >
            View
          </div>
          <div
            className="cursor-pointer text-[#346BFF] underline"
            onClick={() =>
              downloadVoucherAtStoreForSaved(rowData, "Saved")
              // onClickDownloadFile(rowData?.file_id, rowData?.filename)
            }
          >
            Download
          </div>
          <div
            className="cursor-pointer text-[#346BFF] underline"
            onClick={() => {
              deleteVoucher(rowData?.file_id)
            }
            }
          >
            Delete
          </div>
        </div>
      );
    },
  },
];
